export const areaList = [
  {
    name: "전체",
    value: null,
  },
  {
    name: "서울",
    value: [1],
  },
  {
    name: "경기도",
    value: [9],
  },
  {
    name: "인천",
    value: [4],
  },
  {
    name: "강원도",
    value: [10],
  },
  {
    name: "전북/전남",
    value: [13, 14, 5],
  },
  {
    name: "경남/부산",
    value: [16, 2, 7],
  },
  {
    name: "경북/대구",
    value: [15, 3],
  },
  {
    name: "충북/충남",
    value: [11, 12],
  },
  {
    name: "대전/세종",
    value: [6, 8],
  },
  {
    name: "제주도",
    value: [17],
  },
];
